import React from "react";
import { useStyles } from "./styles";

export const NewsWidgetDate = ({ children, ...props }) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const classes = useStyles(props);

  return (
    <div className={classes.date} ref={ref}>
      {children}
    </div>
  );
};
NewsWidgetDate.muiName = "NewsWidgetDate";
NewsWidgetDate.displayName = "NewsWidgetDate";

export default NewsWidgetDate;
